import {
  Product,
  ProductConnection,
  ProductFilter,
} from '@shopify/hydrogen-react/storefront-api-types';

export const INCLUDE_EXCLUSIVE_FILTER = {
  productMetafield: {
    namespace: 'custom',
    key: 'exclusive',
    value: 'true',
  },
};

export const EXCLUDE_EXCLUSIVE_FILTER = {
  productMetafield: {
    namespace: 'custom',
    key: 'exclusive',
    value: 'false',
  },
};

export function removeExclusiveProducts(
  data: Product[] | ProductConnection
): Product[] | ProductConnection {
  if ('edges' in data) {
    const filteredEdges = data.edges.filter(item => {
      return !isExclusiveProduct(item.node);
    });

    return {
      ...data,
      edges: filteredEdges,
    };
  }

  return data.filter(product => {
    return !isExclusiveProduct(product);
  });
}

export function prepareExclusiveFilter(productFilter: ProductFilter[]): ProductFilter[] {
  const helperFilter = [...productFilter];

  if (!userCanLoadExclusiveItems()) {
    const withoutExclusive = helperFilter.filter(item => {
      return !(
        item.productMetafield &&
        item.productMetafield.namespace === 'custom' &&
        item.productMetafield.key === 'exclusive'
      );
    });

    withoutExclusive.push(EXCLUDE_EXCLUSIVE_FILTER);
    return withoutExclusive;
  }

  return helperFilter;
}

export function isExclusiveProduct(product: Product): boolean {
  return (
    !!product.metafield &&
    product.metafield.key === 'exclusive' &&
    product.metafield.value === 'true'
  );
}

export function requireCertificateFields(product: any): boolean {
  return (
    !!product &&
    !!product.certificates &&
    product.certificates.key === 'require_certificates_and_membership_cards_fields' &&
    product.certificates.value === 'true'
  );
}

export function isBundleProduct(product: Product): boolean {
  return (
    product.variants?.edges?.some(item => {
      return item.node.components?.edges?.length;
    }) ?? false
  );
}

export function userCanLoadExclusiveItems(): boolean {
  return false;
}
